// extracted by mini-css-extract-plugin
export default {"background_pic":"CustomerDetail_background_pic__aQd-w"};